// src/features/payments/hooks/usePaymentsOverview.ts
import { useQuery } from '@tanstack/react-query';
import api from 'src/shared/api/axios';

export type PaymentsOverviewMonthlyRow = {
    month: string; // YYYY-MM
    planClient: number;
    planSubcon: number;
    actualClient: number;
    actualSubcon: number;
    planNet: number;
    actualNet: number;

    // cumulative (actual 기반)
    cumClient: number;
    cumSubcon: number;
    netCum: number;
};

export type PaymentsOverviewDto = {
    currency: string | null;
    contracts: { total: number; clientCount: number; subconCount: number };
    totals: {
        clientPlanTotal: number;
        clientActualTotal: number;
        subconPlanTotal: number;
        subconActualTotal: number;
        netPlanTotal: number;
        netActualTotal: number;
    };
    monthly: PaymentsOverviewMonthlyRow[];
};

export const paymentsOverviewKey = (projectId: string, currency?: string | null) =>
    ['paymentsOverview', projectId, currency ?? ''] as const;

export function usePaymentsOverview(projectId: string, currency?: string | null) {
    return useQuery<PaymentsOverviewDto>({
        queryKey: paymentsOverviewKey(projectId, currency),
        queryFn: async () => {
            const { data } = await api.get(`/projects/${projectId}/payments/overview`, {
                params: currency ? { currency } : undefined,
            });
            return (data?.data ?? data) as PaymentsOverviewDto;
        },
        enabled: !!projectId,
        staleTime: 10_000,
    });
}
